"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatestAsyncEffect = useLatestAsyncEffect;
const domain_1 = require("@home-health-notify/domain");
const react_1 = require("react");
/**
 * Like useEffect, but ensures only the latest async effect can update state.
 * Pass an async function as the effect, and it will only run setState if still latest.
 * Uses AbortContext for domain-level cancellation.
 */
function useLatestAsyncEffect(effect, deps, cleanup) {
    const latestRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        latestRef.current += 1;
        const callId = latestRef.current;
        let cancelled = false;
        const abortContext = new domain_1.AbortContext();
        const checkIfLatest = () => !cancelled && callId === latestRef.current;
        (() => __awaiter(this, void 0, void 0, function* () {
            yield effect(checkIfLatest, abortContext);
        }))();
        return () => {
            cancelled = true;
            abortContext.abort();
            if (cleanup)
                cleanup();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
